// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3HGqw","header":"PatientQuestionnaire_header__2-Z1K","info":"PatientQuestionnaire_info__1xNiC"};